// extracted by mini-css-extract-plugin
export default {"wrapper":"TechnicalWorks_wrapper__T3omk","message":"TechnicalWorks_message__q+pbi"};